(function () {
  'use strict';

  var configElement = document.getElementById('OdorDefensePurchasePauseConfig');
  if (!configElement) return;

  var config;
  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    return;
  }

  if (!config.enabled) return;

  var blockedVariantIds = (config.variantIds || []).map(String);
  var originalFetch = window.fetch ? window.fetch.bind(window) : null;
  var cartCheckInFlight = null;
  var cartCheckTimer = null;

  function isBlockedVariant(value) {
    return blockedVariantIds.indexOf(String(value || '')) !== -1;
  }

  function isCartAddUrl(url) {
    return /\/cart\/add(?:\.js)?(?:[/?#]|$)/i.test(String(url || ''));
  }

  function objectContainsBlockedVariant(value, seen) {
    if (value === null || typeof value === 'undefined') return false;
    if (typeof value === 'string' || typeof value === 'number') {
      return isBlockedVariant(value);
    }
    if (typeof value !== 'object') return false;

    seen = seen || [];
    if (seen.indexOf(value) !== -1) return false;
    seen.push(value);

    if (isBlockedVariant(value.id) || isBlockedVariant(value.variant_id) || isBlockedVariant(value.variantId)) {
      return true;
    }

    if (Array.isArray(value)) {
      return value.some(function (item) {
        return objectContainsBlockedVariant(item, seen);
      });
    }

    return Object.keys(value).some(function (key) {
      return objectContainsBlockedVariant(value[key], seen);
    });
  }

  function stringContainsBlockedVariant(value) {
    var text = String(value || '');
    if (!text) return false;

    try {
      if (objectContainsBlockedVariant(JSON.parse(text))) return true;
    } catch (error) {
      // Form-encoded bodies are handled by URLSearchParams below.
    }

    try {
      var params = new URLSearchParams(text);
      var matched = false;
      params.forEach(function (paramValue, key) {
        if (matched) return;
        if (key === 'id' || key === 'variant_id' || /items(?:\[\d+\])?\[id\]/.test(key)) {
          matched = isBlockedVariant(paramValue);
        }
      });
      if (matched) return true;
    } catch (error) {
      // Fall through to an exact ID check for uncommon request encodings.
    }

    return blockedVariantIds.some(function (variantId) {
      return text.indexOf(variantId) !== -1;
    });
  }

  async function bodyContainsBlockedVariant(body) {
    if (!body) return false;

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var formMatched = false;
      body.forEach(function (value, key) {
        if (formMatched) return;
        if (key === 'id' || key === 'variant_id' || /items(?:\[\d+\])?\[id\]/.test(key)) {
          formMatched = isBlockedVariant(value);
        }
      });
      return formMatched;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return stringContainsBlockedVariant(body.toString());
    }

    if (typeof Blob !== 'undefined' && body instanceof Blob) {
      return stringContainsBlockedVariant(await body.text());
    }

    if (typeof body === 'string') return stringContainsBlockedVariant(body);
    return objectContainsBlockedVariant(body);
  }

  async function requestContainsBlockedVariant(input, init) {
    var url = typeof input === 'string' ? input : input && input.url;
    if (!isCartAddUrl(url)) return false;

    if (init && await bodyContainsBlockedVariant(init.body)) return true;

    if (typeof Request !== 'undefined' && input instanceof Request) {
      try {
        return stringContainsBlockedVariant(await input.clone().text());
      } catch (error) {
        return false;
      }
    }

    try {
      var parsedUrl = new URL(String(url), window.location.origin);
      return isBlockedVariant(parsedUrl.searchParams.get('id'));
    } catch (error) {
      return false;
    }
  }

  function openWaitlist(formId) {
    var resolvedFormId = formId || config.formId;
    if (!resolvedFormId) return;

    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(resolvedFormId);
      return;
    }

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', resolvedFormId]);
  }

  function shouldAutoOpenWaitlist() {
    try {
      return new URL(window.location.href).searchParams.get('open_waitlist') === '1';
    } catch (error) {
      return /(?:^|[?&])open_waitlist=1(?:&|$)/.test(window.location.search || '');
    }
  }

  function getAutoOpenWaitlistTrigger() {
    var expectedProductId = String(config.productId || '');
    if (!expectedProductId) return null;

    var purchasePauseBlocks = document.querySelectorAll('[data-odor-defense-purchase-pause]');
    for (var index = 0; index < purchasePauseBlocks.length; index += 1) {
      var block = purchasePauseBlocks[index];
      if (String(block.getAttribute('data-product-id') || '') !== expectedProductId) continue;

      var trigger = block.querySelector('[data-pfm-odor-waitlist-trigger]');
      if (trigger) return trigger;
    }

    return null;
  }

  function autoOpenWaitlistFromUrl() {
    if (!shouldAutoOpenWaitlist()) return;

    var trigger = getAutoOpenWaitlistTrigger();
    if (!trigger) return;

    openWaitlist(trigger.getAttribute('data-klaviyo-form-id'));
  }

  function getToast() {
    var toast = document.querySelector('[data-pfm-purchase-pause-toast]');
    if (toast) return toast;

    toast = document.createElement('div');
    toast.className = 'pfm-purchase-pause-toast';
    toast.hidden = true;
    toast.setAttribute('data-pfm-purchase-pause-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML =
      '<p class="pfm-purchase-pause-toast__message"></p>' +
      '<div class="pfm-purchase-pause-toast__actions">' +
        '<button type="button" class="pfm-purchase-pause-toast__waitlist" data-pfm-odor-waitlist-trigger></button>' +
        '<button type="button" class="pfm-purchase-pause-toast__close" data-pfm-purchase-pause-close aria-label="Close">&times;</button>' +
      '</div>';

    toast.querySelector('.pfm-purchase-pause-toast__message').textContent = config.message;
    toast.querySelector('.pfm-purchase-pause-toast__waitlist').textContent = config.cta;
    document.body.appendChild(toast);
    return toast;
  }

  function showBlockedMessage() {
    var toast = getToast();
    toast.hidden = false;
  }

  function handleBlockedAttempt(openForm) {
    showBlockedMessage();
    if (openForm !== false) openWaitlist();
  }

  function blockedResponse() {
    var payload = JSON.stringify({
      status: 422,
      message: 'Cart Error',
      description: config.message
    });

    if (typeof Response === 'undefined') {
      return Promise.reject(new Error(config.message));
    }

    return Promise.resolve(new Response(payload, {
      status: 422,
      headers: { 'Content-Type': 'application/json' }
    }));
  }

  function variantFromPurchaseElement(element) {
    if (!element) return null;

    var directId = element.getAttribute('data-id') || element.getAttribute('data-variant-id');
    if (isBlockedVariant(directId)) return directId;

    var form = element.closest && element.closest('form');
    if (!form) return null;
    var idInput = form.querySelector('[name="id"], .variant-id');
    return idInput && isBlockedVariant(idInput.value) ? idInput.value : null;
  }

  function scheduleCartCheck(delay) {
    window.clearTimeout(cartCheckTimer);
    cartCheckTimer = window.setTimeout(reconcileCart, typeof delay === 'number' ? delay : 150);
  }

  function reconcileCart() {
    if (!originalFetch || cartCheckInFlight) return cartCheckInFlight;

    cartCheckInFlight = originalFetch(config.cartJsonUrl, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to inspect cart');
        return response.json();
      })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (isBlockedVariant(item.variant_id)) updates[item.key] = 0;
        });

        if (!Object.keys(updates).length) return null;

        return originalFetch(config.cartUpdateUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Unable to remove paused product');
            return response.json();
          })
          .then(function (updatedCart) {
            showBlockedMessage();
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: updatedCart } }));
            document.dispatchEvent(new CustomEvent('cart:build'));
            return updatedCart;
          });
      })
      .catch(function () {
        // Server-side validation remains the definitive launch safeguard.
      })
      .finally(function () {
        cartCheckInFlight = null;
      });

    return cartCheckInFlight;
  }

  document.addEventListener('click', function (event) {
    var waitlistTrigger = event.target.closest && event.target.closest('[data-pfm-odor-waitlist-trigger]');
    if (waitlistTrigger) {
      event.preventDefault();
      openWaitlist(waitlistTrigger.getAttribute('data-klaviyo-form-id'));
      return;
    }

    var closeTrigger = event.target.closest && event.target.closest('[data-pfm-purchase-pause-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeTrigger.closest('[data-pfm-purchase-pause-toast]').hidden = true;
      return;
    }

    var purchaseElement = event.target.closest && event.target.closest(
      '.js-quick-add-btn, .add-to-cart-button, [data-add-to-cart], button[name="add"]'
    );
    var blockedVariant = variantFromPurchaseElement(purchaseElement);

    if (!blockedVariant) {
      var cartLink = event.target.closest && event.target.closest('a[href*="/cart/"]');
      if (cartLink && blockedVariantIds.some(function (variantId) {
        return cartLink.href.indexOf('/cart/' + variantId + ':') !== -1;
      })) {
        blockedVariant = true;
      }
    }

    if (!blockedVariant) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    handleBlockedAttempt(true);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !isCartAddUrl(form.action)) return;

    var idInput = form.querySelector('[name="id"], .variant-id');
    if (!idInput || !isBlockedVariant(idInput.value)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    handleBlockedAttempt(true);
  }, true);

  if (originalFetch) {
    window.fetch = async function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      if (isCartAddUrl(url) && await requestContainsBlockedVariant(input, init)) {
        handleBlockedAttempt(true);
        return blockedResponse();
      }

      var response = await originalFetch(input, init);
      if (isCartAddUrl(url)) scheduleCartCheck(0);
      return response;
    };
  }

  document.addEventListener('ajaxProduct:added', function () {
    scheduleCartCheck(0);
  });
  document.addEventListener('rebuy:cart.change', function () {
    scheduleCartCheck(0);
  });
  window.addEventListener('pageshow', function () {
    scheduleCartCheck(0);
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleCartCheck(0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      autoOpenWaitlistFromUrl();
      scheduleCartCheck(0);
    }, { once: true });
  } else {
    autoOpenWaitlistFromUrl();
    scheduleCartCheck(0);
  }
})();
